// Undo a repeat just booked (8 Oct 2026). The server allows it for 10
// minutes after booking, to whoever booked it (or the owner), and sends the
// client nothing. The repeats this person booked are remembered here (and
// for the tab, in sessionStorage) so the booking panel can offer Undo for
// as long as it's allowed.
export const UNDO_MINUTES = 10
const KEY = 'beu-repeat-undo'
const LIMIT = UNDO_MINUTES * 60 * 1000

const read = () => {
  try { return JSON.parse(sessionStorage.getItem(KEY) || '{}') || {} } catch (e) { return {} }
}
const write = (made) => {
  try { sessionStorage.setItem(KEY, JSON.stringify(made)) } catch (e) { /* only a convenience */ }
}

let made = read()

export const rememberRepeat = (seriesId, at = Date.now()) => {
  if (!seriesId) return
  const now = Date.now()
  // Old ones out, so it never grows
  made = Object.fromEntries(Object.entries(made).filter(([, t]) => now - t < LIMIT))
  made[String(seriesId)] = at
  write(made)
}

// How long is left to undo it, in ms (0 when it's too late or not ours)
export const undoLeft = (seriesId, now = Date.now()) => {
  const at = seriesId ? made[String(seriesId)] : null
  return at ? Math.max(0, LIMIT - (now - at)) : 0
}

export const canUndo = (seriesId, now = Date.now()) => undoLeft(seriesId, now) > 0

export const forgetRepeat = (seriesId) => {
  delete made[String(seriesId)]
  write(made)
}

// "Undo for 7 more minutes"
export const undoLeftSaid = (ms) => {
  const m = Math.ceil(ms / 60000)
  return m <= 1 ? 'Undo for 1 more minute' : `Undo for ${m} more minutes`
}
